export function customScroll() {
  $(window).on("load", function () {
    if($("html").hasClass("no-dev")) {
      $(".scrollable").each(function () {
        $(this).mCustomScrollbar({
          scrollInertia: 0,
          mouseWheelPixels: 170,
          autoDraggerLength: false,
        });
      });
    }
  });
  
}


// WEBPACK FOOTER //
// ./assets/js/modules/customScroll.js